/* eslint-disable react-hooks/exhaustive-deps */
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { AgGridReact } from 'ag-grid-react';
import Axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import "../../CSS/general.css";
import { API_ROUTE, Routes, Urls } from "../../Helpers/Constants";
import AadJobList from "./AADJobList";
import Button from 'react-bootstrap/Button';
import AlertModal from "./AlertMessagePopup";
import { AppContext } from "./AppContext";
import HelpModal from "./HelpMessagePopup";
import JobControlModal from "./JobControlPopup";
import EntraJobControlPopup from "./EntraJobControlPopup";
import NotificationModal from "./NotificationPopup";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import AuthenticationContext from "../../Store/Authentication-Context";
import LoaderGif from "../../images/365 loading.gif";
import GuardianEncryption from "./GuardianEncryption";
import { Modal } from "react-bootstrap";

const JobList = ({ jobsUrl, orgDetails, token, jobSelected, refresh, repositories, isLoading, reloadRepositories, guardianStatusLoaded, priceModel, actualOrgUserCount, isAzureGuardianOnly, isAzureGuardianOnlyLoaded, setActiveTab, entraJobSelected }) => {
    
    const urlParams = new URLSearchParams(window.location.search);
    const { setAuthContext, setRepoData, checkDataForId } = useContext(AuthenticationContext);
    const [appOrg, setAppOrg] = useContext(AppContext);
    const [gridApi, setGridApi] = useState(null);
    const [notificationPopup, setNotificationPopup] = useState(true);
    const [AlertPop, setAlertPop] = useState(true);
    const [jobPopup, setJobPopup] = useState(true);
    const [copyJobPopup, setCopyJobPopup] = useState(false);
    const [copyJobPayload, setCopyJobPayload] = useState([]);
    const [isEditJob, setIsEditJob] = useState(false);
    ////const [isEntraEditJob, setIsEntraEditJob] = useState(false);
    const isEntraEditJob = false;
    const [aadRowdata, setAadRowdata] = useState([]);
    const [enableAadNewJob, setEnableAadNewJob] = useState(false);
    const [openGuardianPopup, setOpenGuardianPopup] = useState(false);
    const [isAADEncryptionKeyEnabled, setIsAADEncryptionKeyEnabled] = useState(false);
    const [jobSelectedSelfUrl, setJobSelectedSelfUrl] = useState("");
    const [jobId, setJobId] = useState("");
    const [popupMessage, setPopupMessage] = useState("");
    const [selectedRowIds, setSelectedRowIds] = useState([]);
    const [retainSelection, setRetainSelection] = useState(true);
    const [alertMessage, setAlertMessage] = useState({
        header: "",
        message: "",
    });
    const [action, setAction] = useState("");
    const orgId = urlParams.get("orgId")
    const orgName = urlParams.get("orgName");
    const [value, setValue] = React.useState(1);
    const feature = useRef([]);
    const copyJobState = useRef(false);
    const tabValue = useRef(1);
    const rowHeight = 25;
    const headerHeight = 30;
    const getRowStyle = params => {
        return { fontSize: "Small" };
    };
    const gridRef = useRef();

    function onFirstDataRendered(params) {
        params.api.sizeColumnsToFit();
    }

    const dateFormatter = (params) => {
        if (params.value === "Disabled")
            return params.Value;
        else if (!params.value)
            return "";

        if (params.value.includes('T')) {
            var dateString = params.value.split('T');
            if (dateString.length > 0) {
                var timeString = dateString[1];
                var parseTime = timeString.substring(0, 8);
                return `${parseDate(dateString[0])} ${parseTime}`;
            }
        } else
            return params.Value
    };
    const dateFormatterForUTC = (params) => {
        const dateValue = params.value;
        if (dateValue === "Disabled") {
            return dateValue;
        }
        if (!dateValue || dateValue === "0001-01-01T00:00:00") {
            return "";
        }

        if (dateValue.includes('T')) {
            ////const [datePart, timePart] = dateValue.split('T');
            ////const formattedDate = parseDate(datePart);
            ////const formattedTime = timePart.substring(0, 8); // Extract HH:mm:ss
            let utcDate = new Date(dateValue);
            let day = String(utcDate.getDate()).padStart(2, '0');
            let month = String(utcDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based
            let year = utcDate.getFullYear();
            let hours = String(utcDate.getHours()).padStart(2, '0');
            let minutes = String(utcDate.getMinutes()).padStart(2, '0');
            let seconds = String(utcDate.getSeconds()).padStart(2, '0');
            // Return formatted date in "DD-MM-YYYY HH:mm"
            return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
            ////return `${formattedDate} ${formattedTime}`;
        }
        return params.value;
        ////return moment(dateValue, 'YYYY-MM-DDTHH:mm:ss.SSSSSSS').format("DD-MM-YYYY HH:mm");
    };

    const parseDate = (date) => {
        var parsedDate = date.split('-');
        return `${parsedDate[2]}-${parsedDate[1]}-${parsedDate[0]}`;
    }
    const statusGetter = (params) => {
        if (params.data.isEnabled)
            return params.data.nextRun;
        else
            return "Disabled";

    };

    const defaultColDef = useMemo(() => ({
        sortable: true,
        resizable: true,
    }), []);
    const onGridReady = (params) => {
        setGridApi(params.api);
        getData(params.api);

        params.api.sizeColumnsToFit();
        params.api.applyColumnState({
            state: [{ colId: 'name_1', sort: 'asc' }],
            defaultState: { sort: null }
        });
    }
    async function getEncyptionKey() {

        const config = {
            headers: {
                Authorisation: `Bearer ` + token,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
       
        Axios.get(API_ROUTE + Routes.GET_ORG_SETTINGS + '/' + urlParams.get("orgId"),  config)
            .then((response) => {
                if (response.data && response.data.encryptionKey)
                    setIsAADEncryptionKeyEnabled(true);

            })
            .catch((reason) => {
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
    }
    const onRowClicked = (params) => {
        setJobSelectedSelfUrl(params.data._links.self.href);
        ////jobSelected("/v8/JobSessions?jobId=" + params.data.id);
        jobSelected(params.data.id);
        setJobId( params.data.id);
    }

    const aadJobSelected = (id) => {
        jobSelected("Entra");
        entraJobSelected(id);
    }
    async function copyJob(payload) {
        
        setCopyJobPopup(true);

        setCopyJobPayload(payload);
    }

    async function confirmCopyJob() {

        setCopyJobPopup(false);
        gridRef.current.api.setGridOption("loading", true);
        const config = {
            headers: {
                Authorisation: `Bearer ` + token,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        copyJobPayload.schedulePolicy.type = copyJobPayload.schedulePolicy.type === 'Daily' ? 'DailyAtTime' : copyJobPayload.schedulePolicy.type;
        await Axios.post(API_ROUTE + Routes.COPY_JOB, copyJobPayload , config)
            .then((response) => {
                    refreshData();
                gridRef.current.api.setGridOption("loading", false);
                })
            .catch((reason) => {
                gridRef.current.api.setGridOption("loading", false);
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
                    return reason.response.data.message
            });


    }

    async function cancelCopyJob() {
        setCopyJobPopup(false);
    }

    async function getOrgDetails() {
        var tokenString = await setAuthContext("", new Date());
        const config = {
            headers: {
                Authorisation: `Bearer ` + tokenString,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

        const data = await Axios.get(API_ROUTE + Routes.GET_PRODUCT_FEATURE + "/" + orgId + "/OLOCKIMMUT", config)
            .then((response) => {
                let result = JSON.parse(response.data);
                feature.current = result;
                return result;
            })
            .catch((reason) => {
                feature.current = [];
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
                return reason;
            });

        return data;
    }

    async function getData(params, repositories) {
        if (!jobsUrl)
            return;
        params.setGridOption("loading", true);
        const config = {
            headers: {
                Authorisation: `Bearer ` + token,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };

        const data = await Axios.get(API_ROUTE + Routes.JOBS(orgId) , config)
            .then((response) => {
                const parsedData = JSON.parse(response.data);
                return parsedData;
            })
            .catch((reason) => {
                closeAlertModal(reason.message);
                params.setGridOption("loading", false);
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });

        const copyData = await Axios.get(API_ROUTE + Routes.COPY_JOBS(appOrg.orgId), config)
            .then((response) => {
                return JSON.parse(response.data);
            })
            .catch((reason) => {
                closeAlertModal(reason.message);
                params.setGridOption("loading", false);
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });

        if (data) {
            let finalResult = [];
            data.forEach(obj => {
                obj.haveCopy = copyData.some(copy => copy._links?.backupJob?.href?.includes(obj.id));
            });
            //console.log(copyData,"joblist")
            if (copyData) {
                finalResult = data.concat(copyData);
            }
            finalResult = finalResult.sort((a, b) => new Date(a.lastBackup) - new Date(b.lastBackup));
            ////params.setRowData(finalResult);
            params.setGridOption('rowData', finalResult);
            //params.setGridOption("loading", false);
            setTimeout((api) =>
                api.setGridOption("loading", false),
                1000, params);
            if (
                data.length === 0 &&
                copyData.length === 0 &&
                (!repositories?.Repositories || repositories.Repositories.length === 0) && repositories !== undefined
            ) {
                handleJobClick("New Job", "");
            }
            if (selectedRowIds.length > 0 && retainSelection) {
                selectedRowIds.forEach((id) => {
                    const rowNode = gridApi && gridApi.getRowNode(id);
                    if (rowNode) {
                        rowNode.setSelected(true);
                    }
                });
            }
        }
    }

    async function getJobData(jobId,isExcluded) {
        const config = {
            headers: {
                Authorisation: `Bearer ` + token,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        const data = await Axios.get(API_ROUTE + Routes.SELECTED_AND_EXCLUDED(appOrg.orgId, jobId, isExcluded), config)
        ////const data = await Axios.post(API_ROUTE + Routes.GET_DATA , payload, config)
            .then((response) => {
                return JSON.parse(response.data);
            })
            .catch((reason) => {
                closeAlertModal(reason.message);
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
        return data;
    }
    async function getEditJobData(params) {
        const config = {
            headers: {
                Authorisation: `Bearer ` + token,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        
        const data = await Axios.get(API_ROUTE + Routes.EDIT_JOB_DETAIL(appOrg.orgId, params), config)

            .then((response) => {
                return JSON.parse(response.data);
            })
            .catch((reason) => {
                closeAlertModal(reason.message);
                if (reason?.response?.status === 440) {
                    window.location.href = "/TimeoutErrorHandler";
                }
            });
        return data;
    }

    async function getRepositories(params) {
        //var token = await loginAuthProvider.getAccessToken();
        //var tokenString = token.accessToken;

        const config = {
            headers: {
                Authorisation: `Bearer ` + token,
                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
            },
        };
        var isRepoAvailable = appOrg?.repositories?.Repositories?.length > 0 ? true : false;
        ////let repoData;
        if (isRepoAvailable) {
            ////repoData = RepoData[orgId]
        }
        else {
            ////repoData = await Axios.get(API_ROUTE + Routes.GET_REPO + "?orgId=" + orgId + "&orgName=" + orgName + "&baseUrl=" + Urls.SERVER_PATH, config)
            await Axios.get(API_ROUTE + Routes.GET_REPO + "/" + orgId , config)
                .then((response) => {
                    let selectItems = JSON.parse(response.data);
                    //setRepoData({ orgId, selectItems });
                    setRepoData({ id: orgId, data: selectItems });

                    setAppOrg((prev) => {
                        return {
                            ...prev,
                            repositories: selectItems
                        }
                    })
                    return selectItems;

                })
                .catch((reason) => {
                    console.log("catch Repo ; " + reason);
                    if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";
                    }
                });
        }

        /* setAppOrg((prev) => {
             return {
                 ...prev,
                 repositories: repoData
             }
         });*/
    }
    //

    const [entraJobPopup, setEntraJobPopup] = useState(false);

    const handleAADJobClick = async (action, jobId) => {

        if (action === 'Edit') {
            setEntraJobPopup(true);
            setAction("edit");
        }
        else {
            if (openGuardianPopup === false && isAADEncryptionKeyEnabled === false) {
                setOpenGuardianPopup(true);
                return;
            }
            else {
                setEntraJobPopup(true);
            }
            setAction("create");
        }
        
        ////setPopupMessage("New Azure backup job will be created and queued for backup. Once the backup is completed you can see the job details.");
        ////setNotificationPopup(false);
    }

    const handleEntraJobClose = (value) => {
        setEntraJobPopup(false);
    }

    //
    

    const handleJobClick = async (action, job) => {
        let jobId = job.id
        setIsEditJob(false);
        copyJobState.current = job.haveCopy;
        getRepositories();
        isLoading(true);

        let jobDetails = {
            name: "",
            description: "",
            isEnabled: true,
            runNow: false,
            backupType: "SelectedItems",
            selectedItems: []
        };
        let jobPartialOrg = [];
        let jobSelectedObjects = [];
        let jobExcludedObjects = [];
        if (jobId) {
            setIsEditJob(true);
            jobDetails = await getEditJobData(jobId);

            if (jobDetails.backupType !== "EntireOrganization") {
                const selectedItems = await getJobData(jobId,true);
                jobDetails.SelectedItems = selectedItems;
                for (var i = 0; i < jobDetails.SelectedItems.length; i++) {
                    let obj = getJobObject(jobDetails.SelectedItems[i], true);
                    if (obj !== undefined)
                        jobSelectedObjects.push(obj);
                }
            }


            if (jobDetails.backupType !== "EntireOrganization") {
                if (jobDetails.SelectedItems.find((y) => y.type === "PartialOrganization")) {
                    let index = jobDetails.SelectedItems.findIndex(x => x.type === "PartialOrganization")
                    if (jobDetails.SelectedItems[index].mailbox === "true")
                        jobPartialOrg.push("mailbox");
                    if (jobDetails.SelectedItems[index].oneDrive ==="true")
                        jobPartialOrg.push("oneDrive");
                    if (jobDetails.SelectedItems[index].archiveMailbox === "true")
                        jobPartialOrg.push("archiveMailbox");
                    if (jobDetails.SelectedItems[index].sites === "true")
                        jobPartialOrg.push("sites");
                    if (jobDetails.SelectedItems[index].teams === "true")
                        jobPartialOrg.push("teams");
                    if (jobDetails.SelectedItems[index].teamsChats === "true")
                        jobPartialOrg.push("teamsChat");
                }
            }
            else {
                jobPartialOrg.push("mailbox");
                jobPartialOrg.push("oneDrive");
                jobPartialOrg.push("archiveMailbox");
                jobPartialOrg.push("sites");
                jobPartialOrg.push("teams");
                if (orgDetails.isTeamsChatsOnline)
                    jobPartialOrg.push("teamsChat");

            }
            const excludedItems = await getJobData(jobId,false);
            jobDetails.ExcludedItems = excludedItems;

            if (excludedItems) {
                for (let i = 0; i < jobDetails.ExcludedItems.length; i++) {
                    let obj = getJobObject(jobDetails.ExcludedItems[i], true);
                    if (obj !== undefined)
                        jobExcludedObjects.push(obj);
                }
            }

        }

        setAppOrg((prev) => {
            return {
                ...prev,
                isTeamsChatsOnline: orgDetails.isTeamsChatsOnline,
                orgDetails: orgDetails,
                token: token,
                job: jobDetails,
                selectedObjects: jobSelectedObjects,
                excludedObjects: jobExcludedObjects,
                partialOrg: jobPartialOrg,
            }
        });

        setRetainSelection(false);
        isLoading(false);
        setJobPopup(false);

    };

    function getJobObject(object, isSelected) {
        switch (object.type) {
            case "User":
                return {
                    id: object.user.id,
                    displayName: object.user.displayName,
                    name: object.user.name,
                    type: object.type,
                    locationType: object.locationType,
                    mailbox: object.mailbox,
                    archiveMailbox: object.archiveMailbox,
                    onedrive: object.oneDrive,
                    site: object.personalSite,
                    itemType: "user",
                    selected: isSelected,
                    excluded: !isSelected
                };
            case "Group":
                return {
                    id: object.group.id,
                    displayName: object.group.displayName,
                    name: object.group.name,
                    type: object.group.type,
                    locationType: object.locationType,
                    mailbox: object.memberMailbox,
                    archiveMailbox: object.memberArchiveMailbox,
                    onedrive: object.memberOnedrive,
                    site: object.memberSite,
                    groupMailbox: object.mailbox,
                    groupSite: object.groupSite,
                    itemType: "group",
                    selected: isSelected,
                    excluded: !isSelected
                };
            case "Team":
                return {
                    id: object.team.id,
                    displayName: object.team.displayName,
                    description: object.team.description,
                    mail: object.team.mail,
                    teams: true,
                    teamsChat: object.teamsChats ? object.teamsChats : false,
                    itemType: "team",
                    selected: isSelected,
                    excluded: !isSelected
                };
            case "Site":
                return {
                    id: object.site.id,
                    url: object.site.url,
                    name: object.site.name,
                    isCloud: object.site.isCloud,
                    isPersonal: object.site.isPersonal,
                    title: object.site.title,
                    itemType: "site",
                    site: true,
                    selected: isSelected,
                    excluded: !isSelected
                };
            default:
                break;
        }
    }

    const columnDefs = [
        {
            field: 'name', headerName: '', minWidth: 168, flex: 1, maxWidth: 168,
            cellRenderer: (params) => <div className="">
                <button className="a-icon" id={"ButtonRunJob" + params.data.name} title="Run job now" style={{ marginRight: '.1rem' }} onClick={() => {
                    closeNotificationModal("run", params.data.name);
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="18" height="18" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
                        {params.data.lastStatus === "Running" ? (                         
                            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
                                    <path d="M3933 5015 c-193 -52 -357 -225 -393 -414 -48 -256 98 -508 348 -598 189 -69 399 -18 548 133 204 208 202 528 -5 735 -134 134 -327 190 -498 144z" />
                                    <path d="M2175 4226 c-16 -7 -220 -194 -453 -415 -489 -466 -477 -450 -477 -601 0 -85 3 -100 27 -141 68 -116 192 -174 318 -148 30 6 74 22 97 35 24 14 168 158 344 344 l302 320 99 0 c55 0 98 -4 96 -8 -1 -5 -302 -342 -666 -750 l-664 -741 -456 -3 c-449 -3 -458 -4 -513 -26 -65 -26 -140 -87 -175 -144 -35 -54 -57 -151 -51 -215 12 -111 91 -228 187 -278 83 -42 132 -45 784 -45 573 0 624 1 653 18 17 9 171 167 343 350 171 183 315 332 319 330 4 -2 126 -126 269 -277 210 -219 261 -277 257 -295 -3 -11 -41 -255 -86 -541 -65 -416 -80 -534 -76 -587 16 -191 184 -332 375 -315 78 8 179 55 226 107 71 79 75 97 225 900 78 415 141 762 141 770 0 8 -171 186 -380 395 l-380 380 293 293 292 292 215 -216 c255 -255 275 -269 400 -269 73 0 92 4 135 27 36 19 169 146 466 445 389 390 418 422 438 476 27 73 27 131 0 204 -25 65 -94 145 -151 174 -87 44 -210 43 -288 -3 -19 -12 -150 -136 -292 -276 -200 -199 -262 -254 -282 -254 -29 0 -20 -9 -405 347 -300 277 -348 316 -410 337 -56 18 -1055 23 -1096 4z" />
                            </g>
                        ) : (
                                <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
                                    <path d="M3401 5104 c-82 -17 -190 -69 -266 -127 -101 -77 -169 -170 -218 -302 -27 -72 -30 -92 -31 -205 -1 -69 2 -139 6 -157 l7 -32 -612 -3 -612 -3 -69 -33 c-83 -39 -146 -88 -185 -145 -36 -53 -404 -720 -445 -807 -60 -128 -46 -305 33 -428 113 -175 326 -253 522 -192 155 47 210 110 389 435 l138 250 121 3 120 3 -361 -631 -361 -630 -521 0 c-566 0 -599 -3 -697 -57 -68 -37 -153 -125 -188 -194 -122 -245 -10 -537 246 -641 l58 -23 704 -3 c483 -2 721 1 758 8 78 17 169 66 227 125 29 29 85 108 129 183 43 73 80 132 83 132 7 0 334 -261 334 -266 0 -3 -70 -179 -155 -390 -168 -416 -181 -462 -164 -580 37 -264 307 -446 562 -379 116 30 217 101 275 192 49 78 480 1159 494 1241 20 121 -20 265 -102 364 -17 20 -154 134 -305 253 -151 119 -275 221 -275 226 0 9 194 346 225 392 11 15 21 3 88 -101 111 -172 186 -237 316 -276 73 -22 201 -20 268 2 28 10 237 121 464 248 454 251 489 277 548 395 148 297 -48 643 -379 666 -118 8 -175 -11 -413 -143 -114 -64 -210 -114 -212 -112 -2 2 -67 100 -144 218 l-140 215 59 16 c402 110 605 561 421 934 -69 138 -169 238 -307 306 -136 66 -288 85 -433 53z m293 -317 c77 -35 140 -98 179 -176 29 -60 32 -73 32 -161 -1 -82 -4 -102 -28 -150 -34 -71 -106 -143 -177 -178 -49 -24 -66 -27 -155 -27 -87 0 -107 3 -155 26 -70 33 -141 103 -177 177 -25 51 -28 68 -28 157 0 90 3 105 28 153 53 101 136 170 236 199 68 19 179 10 245 -20z m-576 -846 c26 -21 71 -52 100 -68 50 -29 63 -46 310 -424 285 -436 292 -444 377 -437 42 4 93 29 315 153 157 87 280 150 301 152 139 19 233 -150 143 -256 -15 -19 -175 -113 -422 -250 -372 -207 -401 -221 -448 -221 -81 0 -101 20 -260 263 -78 120 -152 229 -165 243 -46 49 -139 52 -196 6 -17 -13 -411 -671 -469 -783 -18 -36 -18 -102 1 -139 8 -16 149 -134 332 -278 175 -138 329 -260 342 -273 27 -26 51 -78 51 -114 0 -29 -433 -1116 -458 -1152 -22 -29 -90 -63 -128 -63 -48 1 -109 34 -134 75 -43 70 -40 82 153 561 188 470 197 499 159 557 -29 44 -609 495 -653 509 -50 14 -105 -1 -141 -39 -15 -16 -77 -113 -138 -218 -124 -210 -148 -241 -200 -256 -23 -6 -266 -9 -702 -7 -655 3 -667 3 -694 24 -53 39 -69 71 -69 134 0 63 16 95 69 134 27 21 41 21 624 26 455 4 602 8 619 18 12 7 33 27 46 45 13 17 225 384 471 815 308 537 449 794 453 820 6 51 -30 119 -77 144 -32 16 -65 18 -363 18 -376 0 -377 0 -425 -79 -16 -25 -93 -165 -173 -310 -161 -294 -176 -312 -262 -318 -96 -7 -167 60 -167 157 0 41 23 88 206 420 113 206 213 384 222 394 10 10 31 27 47 37 28 18 65 19 693 19 l663 0 47 -39z" />
                                </g>
                        )}
                    </svg>
                </button>
                <button className="a-icon" id={"ButtonStopJob" + params.data.name} title="Stop job" style={{ marginRight: '.1rem' }} onClick={() => {
                    if (params.data.lastStatus === "Running")
                        closeNotificationModal("stop", params.data.name);
                    else
                        closeAlertModal("Unable to stop the job. The job is not running.")
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill={params.data.lastStatus === "Stopped" ? "red" : "currentColor"} className="bi bi-stop-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                        <path d="M5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5z" />
                    </svg>
                </button>
                <button className="a-icon" id={"ButtonDisableJob" + params.data.name} title="Disable job" style={{ color: params.data.isEnabled ? "currentColor" : "red", marginRight: '.1rem' }} onClick={() => {
                    closeNotificationModal("disable", params.data.name);
                }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill={params.data.isEnabled ? "currentColor" : "red"} className="bi bi-pause-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                        <path d="M5 6.25a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0zm3.5 0a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0z" />
                    </svg>
                </button>
                <button className="a-icon" id={"ButtonEnableJob" + params.data.name} title="Enable job" style={{ marginRight: '.1rem' }} onClick={() => {
                    //if (params.data.lastStatus === "Running")
                    closeNotificationModal("enable", params.data.name);

                }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-play-circle" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                            <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" />
                    </svg>
                </button>

                {!params.data.name.toLocaleLowerCase().includes('- copy job') ?
                    <button className="a-icon" id={"ButtonEditJob" + params.data.name} title="Edit job" style={{ marginRight: '.1rem' }}
                        onClick={() => { handleJobClick("Edit Job", params.data) }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                            <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                        </svg>
                    </button> :
                    <abutton className="a-icon" id={"ButtonEditJob" + params.data.name} title="Cannot edit copy job" style={{ pointerEvents: "none", marginRight: '.1rem' }}
                        onClick={() => { return; }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="gray" className="bi bi-pencil-square" viewBox="0 0 16 16">
                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                            <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                        </svg>
                    </abutton>
                }

                <button className="a-icon" id={"ButtonDeleteJob" + params.data.name} title="Delete job" onClick={() => {
                    closeNotificationModal("delete", params.data.name);
                }
                }>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                    </svg>
                </button>

                {!params.data.name.toLocaleLowerCase().includes('- copy job') &&
                    ((feature.current.length === 0 || feature.current?.featureValue === "") || params.data.haveCopy ?
                    <button className="a-icon" id={"copyjob" + params.data.name} title={params.data.haveCopy ? "Copy job already exists" :"Copy job feature is not included in your package."} style={{ marginRight: '.1rem' }}
                        onClick={() => {  }}
                        >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="gray" className="bi bi-copy" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z" />
                        </svg>
                    </button>
                    : <button className="a-icon" id={"Copyjob" + params.data.name} title="Copy job" style={{ marginRight: '.1rem' }}
                        onClick={() => { copyJob(params.data) }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-copy" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z" />
                        </svg>
                    </button>) 
                }
            </div >
        },
        { field: 'name', filter: true, headerName: 'Name', minWidth: 220, flex: 1, sortable: true },
        { field: 'lastStatus', filter: true, headerName: 'Status', minWidth: 100, maxWidth: 120, flex: 1 },
        /*  {
              field: 'lastStatus', headerName: 'Status', valueGetter:  statusGetter,
             
          },*/
        { field: 'description', filter: true, headerName: 'Description', minWidth: 200, flex: 1 },
        {
            field: 'lastBackup', headerName: 'Last Backup', valueFormatter: dateFormatterForUTC, minWidth: 160, flex: 1,
            getQuickFilterText: params => {
                return dateFormatter(params);
            }
        },
        {
            field: 'nextRun', headerName: 'Next Run', valueFormatter: dateFormatterForUTC, valueGetter: statusGetter, minWidth: 160, flex: 1,
            getQuickFilterText: params => {
                return dateFormatter(params);
            }
        }
    ];


    async function runJob(params) {
        setRetainSelection(true);
        async function setData() {

            if (!params)
                return;
            params.setGridOption("loading", true);
            //var token = await loginAuthProvider.getAccessToken();
            //var tokenString = token.accessToken;
            const config = {
                headers: {
                    Authorisation: `Bearer ` + token,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            console.log(params);
            let payload = {
                postString: "{\"full\":false}",
                method: "POST",
                jobId: jobId,
                action:"run",
                orgId: appOrg.orgId,
            };
            await Axios.post(API_ROUTE + Routes.START_JOB.replace("{jobId}", jobId), payload, config)
                .then(async (response) => {
                    await getData(params);
                    return response;
                })
                .catch((reason) => {
                    closeAlertModal(reason.message);
                    params.setGridOption("loading", false);
                    if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";
                    }
                });
        }
         await setData();
        params.setGridOption("loading", false);
    }

    async function manageJob(params, action) {
        setRetainSelection(true);
        async function setData() {
            if (!gridApi && !gridRef && !gridRef.current && !gridRef.current.api)
                return;
            if (gridRef.current)
                gridRef.current.api.setGridOption("loading", true);
            //var token = await loginAuthProvider.getAccessToken();
            //var tokenString = token.accessToken;
            const config = {
                headers: {
                    Authorisation: `Bearer ` + token,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            let payload = {
                postString: "",
                method: "POST",
                //   url: jobSelectedSelfUrl + "/" + action,
                action: action,
                jobId: jobId,
                orgId: appOrg.orgId,
            };

            let apiUrl = API_ROUTE + Routes.EDIT_JOB + "/" + jobId;
            let httpMethod = "post";
            switch (action) {
                case "enable":
                    apiUrl = API_ROUTE + Routes.ENABLE_JOB.replace("{jobId}", jobId);
                    break;

                case "disable":
                    apiUrl = API_ROUTE + Routes.DISABLE_JOB.replace("{jobId}", jobId);
                    break;

                case "stop":
                    apiUrl = API_ROUTE + Routes.STOP_JOB.replace("{jobId}", jobId);
                    break;

                default: apiUrl = API_ROUTE + Routes.EDIT_JOB + "/" + jobId;
                    httpMethod = "put";
                    break;
            }
            await Axios[httpMethod](apiUrl, payload, config)
                .then((response) => {

                    setTimeout(() => { getData(params); }, 5000);
                    gridApi.setGridOption("loading", false);
                    return response;
                })
                .catch((reason) => {
                    closeAlertModal(reason.message);
                    params.setGridOption("loading", false);
                    if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";
                    }
                });

        }
        await setData();
        gridApi.setGridOption("loading", false);

    }
    async function createAADJob(params, action) {
        setRetainSelection(true);
        async function setData() {

            //var token = await loginAuthProvider.getAccessToken();
            //var tokenString = token.accessToken;
            const config = {
                headers: {
                    Authorisation: `Bearer ` + token,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };
            let orgId = urlParams.get("orgId") ? urlParams.get("orgId") : sessionStorage.getItem("ManageOrgId");
            await Axios.post(API_ROUTE + Routes.CREATE_NEW_AAD_JOB(orgId, orgDetails.name), null, config)
                .then((response) => {

                    //setTimeout(() => { getData(params); }, 5000);
                    //gridApi.hideOverlay();
                    jobSelected("");
                    //setValue(0);
                    setActiveTab("Azure")
                    if (isAzureGuardianOnly) {
                        setValue(1);
                    }
                    else {
                        setValue(2);
                    }
                    
                    return response;
                })
                .catch((reason) => {
                    closeAlertModal(reason.message);
                    //params.hideOverlay();
                    if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";
                    }
                });

        }
        await setData();
        //gridApi.hideOverlay();

    }


    async function deleteJob(params) {
        setRetainSelection(true);
        async function setData() {
            if (!params)
                return;

            params.setGridOption("loading", true);
            //var token = await loginAuthProvider.getAccessToken();
            //var tokenString = token.accessToken;
            const config = {
                headers: {
                    Authorisation: `Bearer ` + token,
                    CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),
                },
            };

            let payload = {
                postString: "",
                method: "DELETE",
                // url: jobSelectedSelfUrl,
                action: "delete",
                jobId: jobId,
                orgId: appOrg.orgId,
            };

            await Axios.delete(API_ROUTE + Routes.DELETE_JOB + "/" + jobId + '/' +  appOrg.orgId , config)
                .then((response) => {
                    getData(params);
                    jobSelected("");
                    return response.data;
                })
                .catch((reason) => {
                    if (reason.response && reason.response.data && reason.response.data.message)
                        closeAlertModal(reason.response.data.message);
                    else if (reason.message.includes("status code 409"))
                        closeAlertModal("Stop Job to complete action.");
                    else if (reason?.response?.status === 440) {
                        window.location.href = "/TimeoutErrorHandler";
                    }
                    else
                        closeAlertModal(reason.message);
                    params.setGridOption("loading", false);
                });
        }
        await setData();
        params.setGridOption("loading", false);
    }

    function closeNotificationModal(action, jobName) {
        setAction(action);
        setPopupMessage("Are you sure you want to " + action + " the job - " + jobName);
        setNotificationPopup(false);
    }
    
    async function getAADJobData(newValue, inLoop) {

        //var token = await loginAuthProvider.getAccessToken();

        //var tokenString = token.accessToken;

        // params.showLoadingOverlay();
        tabValue.current = newValue;
        const tokenString = await setAuthContext("", new Date());

        const config = {

            headers: {

                Authorisation: `Bearer ` + tokenString,

                CloudCoverToken: sessionStorage.getItem('CloudCoverToken'),

            },

        };


        var tenantDomain = sessionStorage.getItem('ManageTenantDomain') ? sessionStorage.getItem('ManageTenantDomain') : ""

        ////if (orgDetails.name) {

        if (orgName) {


            Axios.get(API_ROUTE + Routes.CHK_GUARDIAN_CONFIG(orgId, tenantDomain), config)

                .then((response) => {

                    //console.log(response);

                    if (response.data === "true") {

                        setEnableAadNewJob(true);

                    }

                    else

                        setEnableAadNewJob(false);

                })

                .catch((reason) => {

                    // params.hideOverlay();

                });

            setEnableAadNewJob(false);


            await Axios.get(API_ROUTE + Routes.GUARDIAN_JOB(orgId, tenantDomain), config)

                .then((response) => {

                    let rowData = [];
                    rowData = JSON.parse(response.data);

                    setAadRowdata(rowData);

                    if (!inLoop) {

                        jobSelected("");

                        setValue(newValue);

                        if (isAzureGuardianOnly) {

                            setActiveTab("Azure");

                        }

                        else {

                            if (newValue === 1) {

                                setActiveTab("365");

                            }

                            else {

                                setActiveTab("Azure");

                            }

                        }

                    }

                    return rowData;

                })

                .catch((reason) => {

                    // params.hideOverlay();

                    return false

                });

        }

        else {

            return true;

        }

    }


    function closeAlertModal(alertMessage) {
        setAlertMessage({
            header: "Error",
            message: alertMessage,
        });
        setAlertPop(false);
    }

    function cancelClick() {
        setNotificationPopup(true);
    }
    function cancelAlertClick() {
        setAlertPop(true);
    }
    function cancelGuardianClick() {
        setOpenGuardianPopup(false);

    }

    function submitGuardianClick(action) {
        
            setIsAADEncryptionKeyEnabled(true);
        setEntraJobPopup(true);
            
    }
    function submitClick(action) {
        if (action === "delete") {
            deleteJob(gridApi);
            return;
        }
        if (action === "run") {
            runJob(gridApi);
            return;
        }
        if (action === "create") {

            if (openGuardianPopup === false && isAADEncryptionKeyEnabled === false) {
                setOpenGuardianPopup(true);
                return;
            }
            else {
                createAADJob(gridApi);
            }
            //aadJobSelected();
        }
        if (gridApi) {
            manageJob(gridApi, action);
        }
        setNotificationPopup(true);
    }

    function closeJobModal(params) {

        setJobPopup(params);
    }
    function aadCallBackRefresh() { refreshADDData(); }
    function refreshData() {
        setRetainSelection(true);
        getData(gridApi);
        refresh();
    }
    function refreshADDData() {
        setRetainSelection(true);
        if (isAzureGuardianOnly) {
            getAADJobData(1,false);
        }
        else {
            getAADJobData(2,false)
        }
        
        refresh();
    }


    useEffect(() => {

        if (gridApi) {
            setSelectedRowIds([]);
            getData(gridApi, repositories);

        }
        if (isAzureGuardianOnly) {
            getAADJobData(1,false);
        }
        setAppOrg((prevOrg) => ({
            ...prevOrg, // Spread the previous state
            orgId: orgId,
            orgName: orgName,
            tenantId: orgDetails.name,
            job: {
                name: "",
                description: "",
                isEnabled: true,
                runNow: false,
                backupType: "SelectedItems",
                selectedItems: []
            },
            selectedObjects: [],
            excludedObjects: [],
            //partialOrg: [],
            isEditJob: false
        }));
    }, [jobsUrl]);
    useEffect(() => {
        if (isAzureGuardianOnly) {
            getAADJobData(1,false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAzureGuardianOnly]);
    //const aadRowdataRef = useRef(aadRowdata);
    //useEffect(() => {
    //    aadRowdataRef.current = aadRowdata;
    //}, [aadRowdata]);
    const statusUpdateCheck = async () => {
        if (Object.keys(priceModel).length !== 0 && priceModel.features.find(feature => feature.featureType === "AZURE") !== undefined && priceModel.features.find(feature => feature.featureType === "AZURE").featureValue.toLowerCase() === "true") {
            if (!isAzureGuardianOnly && tabValue.current === 2) {
                var success = await getAADJobData(tabValue.current, true);
            }
            else if (isAzureGuardianOnly && tabValue.current === 1) {
                success = await getAADJobData(tabValue.current, true);
            }
            
            if (success) {
                setTimeout(() => {
                    statusUpdateCheck();
                }, 10000);
            } else {
                setTimeout(() => {
                    statusUpdateCheck();
                }, 10000);
            }
        }
        
    };
   
    useEffect(() => {
        getOrgDetails();
    }, []);
    useEffect(() => {
        statusUpdateCheck();
    }, [priceModel]);
    useEffect(() => {
            
        }, [feature])
    return (

        <div className="card mt-1" id="joblist">
            <div className="row">
                <div className="col-md-8">
                    <Tabs
                        id="JoblistTab"
                        value={value}
                        textColor="primary"
                        indicatorColor="primary"
                        sx={{ "& .MuiTabs-indicator": { display: "none" } }}
                        onChange={(event, newValue) => {
                            getAADJobData(newValue,false);
                            getEncyptionKey();

                        }}>
                        <Tab
                            label="Jobs List"
                            className="p-0"
                            id="job_list_tab"
                        />
                        {isAzureGuardianOnlyLoaded && ( !isAzureGuardianOnly && <Tab label="365" id="tab_365" />)}
                        {isAzureGuardianOnlyLoaded && (!guardianStatusLoaded ?
                            <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip-diskspace">Loading..</Tooltip>}>
                                <div style={{ cursor: "not-allowed" }}>
                                    <Tab label="Azure" disabled={true} id="tab_azure" />
                                </div>
                            </OverlayTrigger>
                            : (Object.keys(priceModel).length !== 0 && priceModel.features.find(feature => feature.featureType === "AZURE") !== undefined && priceModel.features.find(feature => feature.featureType === "AZURE").featureValue.toLowerCase() === "true") ? <Tab label="Azure" id="tab_azure" /> :
                                <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip-diskspace">Not Available in your selected package</Tooltip>}>
                                    <div style={{ cursor: "not-allowed" }}>
                                        <Tab label="Azure" disabled={true} id="tab_azure" />
                                    </div>
                                </OverlayTrigger> )}


                    </Tabs>
                </div>
                {!isAzureGuardianOnly && value === 1 &&
                    <div className="col-md-4 pe-3 d-flex justify-content-end align-items-center" >
                        <span className="SectionTitle" style={{ paddingLeft: '48px', cursor: 'pointer' }} >
                            {repositories.Repositories ? <button className="a-icon me-2 a-btn" id="CreateNewJobBtn"
                                onClick={() => { handleJobClick("New Job", "") }}

                            >
                                <svg style={{ marginBottom: '.1rem' }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 448 512">
                                    <path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z">
                                    </path></svg> New Job </button>
                                :
                                <button className="a-icon me-2 a-btn" id="CreateNewJobBtn" style={{  cursor: 'not-allowed' }}

                                >
                                    <svg style={{ marginBottom: '.1rem' }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 448 512">
                                        <path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z">
                                        </path></svg> New Job </button>
                            }

                            <button className="a-icon" id="Job_btnReload" title="Refresh" onClick={() => refreshData()}>

                                <svg style={{ marginBottom: '.1rem' }} className="me-2 ms-1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" viewBox="0 0 512 512">
                                    <path fill="currentColor" d="M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z">
                                    </path>
                                </svg> </button>
                            <button id="ContentPlaceHolder1_btnClear" title="Clear Filter" style={{ cursor: 'pointer', height: "25", width: "25" }} className="me-1 mainpage_clear a-icon" onClick={(e) => {
                                if (gridApi) {
                                    gridApi.setFilterModel(null);
                                }
                            }}>
                                <svg xmlns="http://www.w3.org/2000/svg" height="23" fill="#007bff" stroke="currentColor" viewBox="0 0 32 32" width="23" style={{ cursor: 'pointer' }}>
                                    <path strokeWidth="1.5" d="m30 11.414-1.414-1.414-4.586 4.586-4.586-4.586-1.414 1.414 4.586 4.586-4.586 4.585 1.415 1.415 4.585-4.586 4.587 4.586 1.413-1.413-4.586-4.587z"></path>
                                    <path strokeWidth="1.5" d="m4 4a2 2 0 0 0 -2 2v3.1709a2 2 0 0 0 .5859 1.4145l7.4141 7.4146v8a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-2h-2v2h-4v-8.8291l-.5859-.5855-7.4141-7.4145v-3.1709h20v2h2v-2a2 2 0 0 0 -2-2z"></path>
                                </svg>
                            </button>
                            <HelpModal about="JobManagement.html" />
                        </span>
                    </div> }
                {!isAzureGuardianOnly && value === 2 && <div className="col-md-4 pe-3 d-flex justify-content-end align-items-center">
                    <span className="SectionTitle" style={{ paddingLeft: '48px' }} >
                        {(Object.keys(priceModel).length !== 0 && priceModel.features.find(feature => feature.featureType === "AZURE") !== undefined && priceModel.features.find(feature => feature.featureType === "AZURE").featureValue.toLowerCase() === "true") ? (enableAadNewJob ? (<button className="a-icon a-btn" id="CreateNewAADJobBtn"
                            onClick={() => { handleAADJobClick("AAD", "") }}>
                            <svg style={{ marginBottom: '.1rem' }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 448 512">
                                <path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z">
                                </path></svg> New Job </button>) :
                            (
                                <button className="a-icon a-btn" id="CreateNewAADJobBtn" onClick={() => { handleAADJobClick("AAD", "") }} 

                                    >
                                        <svg style={{ marginBottom: '.1rem' }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 448 512">
                                            <path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z">
                                            </path></svg> New Job </button>

                            )
                        ) : (<OverlayTrigger placement='bottom' overlay={<Tooltip id="tooltip-CreateNewAADJobBtnDisabled">Not Available in your selected package</Tooltip>}
                            delay={{ show: 500, hide: 2000 }} >
                                <button className="a-icon" id="CreateNewAADJobBtn" style={{ color: "#007bff" }} onClick={() => { handleAADJobClick("AAD", "") }}

                            >
                                <svg style={{ marginBottom: '.1rem' }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 448 512">
                                    <path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z">
                                    </path></svg> New Job </button>
                        </OverlayTrigger>)}
                        <button className="a-icon" id="Job_btnAADReload" title="Refresh" onClick={() => refreshADDData()}>
                            <svg style={{ marginBottom: '.1rem' }} className="me-1 ms-1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" viewBox="0 0 512 512">
                                <path fill="currentColor" d="M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z">
                                </path>
                            </svg> </button>
                    </span>
                </div>}
                {isAzureGuardianOnly && value === 1 && <div className="col-md-4 pe-3 d-flex justify-content-end align-items-center">
                    <span className="SectionTitle" style={{ paddingLeft: '48px' }} >
                        {(Object.keys(priceModel).length !== 0 && priceModel.features.find(feature => feature.featureType === "AZURE") !== undefined && priceModel.features.find(feature => feature.featureType === "AZURE").featureValue.toLowerCase() === "true") ? (enableAadNewJob ? (<button className="a-icon" id="CreateNewAADJobBtn" style={{ color: "#007bff" }}
                            onClick={() => { handleAADJobClick("AAD", "") }}>
                            <svg style={{ marginBottom: '.1rem' }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 448 512">
                                <path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z">
                                </path></svg> New Job </button>) :
                            (
                                <OverlayTrigger placement='bottom' overlay={<Tooltip id="tooltip-CreateNewAADJobBtnDisabled">You need to rerun setup to use this service, go to the settings page and click update link, a guide to this process can be found <a href="https://cloudcover365.virtualdcs.co.uk/v4/CloudCoverGuardian.html" target="_blank" rel="noopener noreferrer" style={{ color: 'blue' }}>
                                    Here
                                </a></Tooltip>}
                                    delay={{ show: 500, hide: 2000 }} >
                                    <button className="a-icon" id="CreateNewAADJobBtnDisabled1" style={{ color: "#007bff", cursor: "not-allowed" }}

                                    >
                                        <svg style={{ marginBottom: '.1rem' }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 448 512">
                                            <path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z">
                                            </path></svg> New Job </button>
                                </OverlayTrigger>

                            )
                        ) : (<OverlayTrigger placement='bottom' overlay={<Tooltip id="tooltip-CreateNewAADJobBtnDisabled">Not Available in your selected package</Tooltip>}
                            delay={{ show: 500, hide: 2000 }} >
                                <button className="a-icon" id="CreateNewAADJobBtnDisabled2" style={{ color: "#007bff", cursor: "not-allowed" }}

                            >
                                <svg style={{ marginBottom: '.1rem' }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 448 512">
                                    <path fill="currentColor" d="M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z">
                                    </path></svg> New Job </button>
                        </OverlayTrigger>) }
                        <button className="a-icon" id="Job_btnAADReload" title="Refresh" onClick={() => refreshADDData()}>
                            <svg style={{ marginBottom: '.1rem' }} className="me-1 ms-1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" viewBox="0 0 512 512">
                                <path fill="currentColor" d="M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z">
                                </path>
                            </svg> </button>
                    </span>
                </div>}

            </div>
            {!isAzureGuardianOnly && value === 1 &&
                <div>
                    <div className="card-body p-0">
                        <div id="ContentPlaceHolder1_UpdatePanelJobList">
                            <div id="ContentPlaceHolder1_Panel3" style={{ height: "180px", width: "100%" }}>
                                <div className="ag-theme-alpine p-1 pt-0" style={{  width: "100%", height: "180px", borderCollapse: "collapse" }} >
                                    {(jobsUrl.length > 0) ?
                                        <AgGridReact style={{ width: "80%" }}
                                            ref={gridRef}
                                            onFirstDataRendered={onFirstDataRendered}
                                            getRowStyle={getRowStyle}
                                            onRowClicked={onRowClicked}
                                            onGridReady={onGridReady}
                                            defaultColDef={defaultColDef}
                                            rowSelection={{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }}
                                            rowBuffer={500}
                                            columnDefs={columnDefs}
                                            headerHeight={headerHeight}
                                            enableCellTextSelection="true"
                                            ensureDomOrder="true"
                                            onSelectionChanged={(e) => {
                                                const selectedNodes = e.api.getSelectedNodes();
                                                if (selectedNodes.length === 0) return;
                                                const selectedRowIds = selectedNodes
                                                    .map((n) => n.id);
                                                setSelectedRowIds(selectedRowIds);
                                            }}
                                            overlayLoadingTemplate={
                                                `<div style="position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);"><div><div style="text-align: center;"><img src="${LoaderGif}" alt="loading" style="height: 50px;"></div><span>Please wait while your rows are loading...</span></div></div>`}
                                            overlayNoRowsTemplate={
                                                '<span className="ag-overlay-loading-center">No records to show</span>'
                                            }
                                            suppressScrollOnNewData={retainSelection}
                                            rowHeight={rowHeight}
                                        >
                                        </AgGridReact>
                                        :
                                        <div>Loading...</div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                </div>}
            {!isAzureGuardianOnly && value === 2 &&
                <AadJobList onJobSelect={aadJobSelected} rowData={aadRowdata} handleAADJobClick={handleAADJobClick} token={token} refresh={aadCallBackRefresh} isAzureAvailable={(Object.keys(priceModel).length !== 0 && priceModel.features.find(feature => feature.featureType === "AZURE") !== undefined && priceModel.features.find(feature => feature.featureType === "AZURE").featureValue.toLowerCase() === "true")} />}
            {isAzureGuardianOnly && value === 1 && 
                <AadJobList onJobSelect={aadJobSelected} rowData={aadRowdata} handleAADJobClick={handleAADJobClick} token={token} refresh={aadCallBackRefresh} isAzureAvailable={(Object.keys(priceModel).length !== 0 && priceModel.features.find(feature => feature.featureType === "AZURE") !== undefined && priceModel.features.find(feature => feature.featureType === "AZURE").featureValue.toLowerCase() === "true")} />}
            <NotificationModal displayModal={!notificationPopup} closeModal={cancelClick} message={popupMessage} submitClick={submitClick} action={action} />
            <AlertModal displayModal={!AlertPop} closeModal={cancelAlertClick} message={alertMessage} />
            <GuardianEncryption displayModal={openGuardianPopup} closeModal={cancelGuardianClick} submitClick={submitGuardianClick} action={action} />
            <JobControlModal displayModal={!jobPopup} closeModal={closeJobModal} jobRefresh={refreshData} isEditJob={isEditJob} copyJobState={copyJobState.current} reloadRepositories={reloadRepositories} actualOrgUserCount={actualOrgUserCount} />
            <EntraJobControlPopup entraJobPopup={entraJobPopup} closeModal={handleEntraJobClose} isEditJob={isEntraEditJob} refresh={aadCallBackRefresh} />
            <Modal
                show={copyJobPopup}
                onHide={cancelCopyJob}
                centered
                size="lg"
            >
                <Modal.Header style={{ padding: 0 }}>
                    <Modal.Title id="exampleModalLabel" style={{ textAlign: "left", width: "100%" }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 style={{ margin: "10px" }}>Create Backup copy jobs</h3>
                            <button type="button" className="btn-close" aria-label="Close" style={{ transform: 'scale(0.75)', marginRight: "5px" }} onClick={cancelCopyJob}></button>
                        </div>

                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/*<hr style={{ borderTop: "1px solid #2671bfcc", margin: "10epx 0" }} />*/}
                    <h5 style={{ margin: "10px" }}>Are you sure you want to create the Backup copy jobs for Job "{copyJobPayload.name}"?</h5>
                    {false && <div style={{ position: 'absolute', height: '100%', width: '96%', background: 'white', top: '0px', opacity: '0.8' }}>
                        <div className="justify-content-center align-items-center d-flex h-100" >
                            <img src={LoaderGif} alt="loading" style={{ height: '50px' }} />
                        </div>
                    </div>}
                    <div className="mt-3" >
                        <div style={{ fontFamily: "'Poppins', sans-serif", fontSize: 'xx-small' }} >&nbsp;&nbsp;* Backup copy jobs copy data to a second location, where they will be held immutable.
                        </div> 
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => {
                        confirmCopyJob();
                    }} >
                        Confirm
                    </Button>
                    <Button variant="secondary" onClick={() => {
                        setCopyJobPopup(false);
                    }} >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
export default JobList;
